/* eslint-disable no-magic-numbers */
import Sizes from 'Sizes';

import {Platform, StyleSheet} from 'react-native';

export default StyleSheet.create({
  container: {
    ...Platform.select({
      web: {
        flex: 1,
      },
      native: {
        flexGrow: 1,
      },
    }),
  },

  list: {
    flex: 1,
    paddingHorizontal: Sizes.select({
      phone: 0,
      tablet: Sizes.isPortrait() ? 55 : 15,
    }),
    paddingTop: Sizes.select({phone: 24, tablet: 40}),
  },
});
